// This is the single entry point for the webpack bundle.

// Basically, anything that isn't imported here or by a module
// imported here, won't be included in the final js.

// Absolute imports
import '@acura/riot-banner';
import '@acura/shared-components/src/components/acr-svg/acr-svg.tag';
import './containers/ui-modal/ui-modal.tag';
import './containers/tabs/tabs.tag';
import './containers/tabs/tab-list.tag';
import './containers/tabs/tab.tag';
import './containers/tabs/tabs-content.tag';
import './containers/tabs/tab-panel.tag';

// We import all the riot mixins and @ the initialization
import riot from 'riot';
import mixin from 'riot-redux-mixin';

import bus from './core/events/bus';
import sharedObservable from './core/mixins/sharedObservable';
import content from './core/mixins/content';
import { getCookie, setCookie } from './core/mixins/cookie';
import redux from './core/app';
import store from './core/store/store';
import fetchInterceptor from './core/fetchInterceptor';
import queryParams from './core/queryParams';
import cookie from './core/cookie';

// And import all the tags
import './containers/offers-wrapper/offers-wrapper.tag';
import './containers/banner/banner.tag';
import './containers/event-delegator/event-delegator.tag';
import './containers/event-delegator-wrapper/event-delegator-wrapper.tag';
import './containers/no-results/no-results.tag';
import './containers/offers-filter/offers-filter.tag';
import './containers/offers-container.tag';
import './containers/offer-detail-container/offer-detail-container.tag';
import './containers/offer-detail-modal/offer-detail-modal.tag';

import './components/offer-notification/offer-notification.tag';
import './components/educational-link/educational-link.tag';
import './components/offers-group/offers-group.tag';
import './components/vehicle-dropdown/vehicle-dropdown.tag';
import './components/disclaimer-component/disclaimer-component.tag';
import './components/offer-detail/offer-detail.tag';
import './components/raw-html/raw-html.tag';
import './components/responsive-image/responsive-image.tag';
import './components/header-banner/header-banner.tag';
import './components/offer-raw-html/offer-raw-html.tag';
import './components/platform-offer-card/platform-offer-card.tag';

const main = {
  init: function init(mountCallback, events) {
    const busRiot = bus;
    fetchInterceptor();

    if (mountCallback) {
      busRiot.on(busRiot.EVENTS.APP.MOUNT, mountCallback);
    }

    if (events) {
      events.forEach((event) => {
        const eventGroup = event.eventName.split('.')[0];
        const eventName = event.eventName.split('.')[1];

        busRiot.on(busRiot.EVENTS[eventGroup][eventName], event.callback);
      });
    }

    riot.mixin('redux', mixin(store));
    riot.mixin('bus', sharedObservable(busRiot));
    riot.mixin(content);
    riot.mixin({
      cookie: {
        set: setCookie,
        get: getCookie,
      },
    });

    // TODO: Change redux initialization to be redux.init()
    redux();

    cookie();

    queryParams();

    // And just mount the parent tag that wraps the rest of the tags
    const eventDelegatorWrapper = riot.mount('offers-event-delegator-wrapper');
    const offersModal = riot.mount('ui-modal');
    const offersWrapper = riot.mount('offers-wrapper');
    const offersZipgate = riot.mount('offers-zipgate');

    return {
      eventDelegatorWrapper,
      offersModal,
      offersWrapper,
      offersZipgate,
      bus: busRiot,
    };
  },
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.Utility) {
    window.Utility.loadSvgInMemory();
  }
});

export default main;

if (process.env.NODE_ENV !== 'production') {
  window.offers = main;
}
